import React from 'react'
import Label from "components/general/Label"
import { ColumnRank, ColumnStartOrder, ColumnName, ColumnNoc, ColumnResult, ColumnExpander, ColumnRecords, ColumnQualification } from "components/common/TableColumns"

export default function TableColumns() {
  return (
    [
      ColumnStartOrder({}),
      ColumnRank({}),
      ColumnNoc({}),
      ColumnName({}),
      ColumnTens({}),
      ColumnXs({}),
      ColumnResult({ label: 'HeaderScore' }),
      ColumnShootoff({}),
      ColumnRecords({}),
      ColumnQualification({}),
      ColumnExpander({ type: 'alwaysTrue' })
    ]
  )
}

function ColumnShootoff({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-5',
  label = ''
}) {
  return (
    {
      Header: <Label data={label} />,
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Shootoff',
      Cell: (props) => (
        <>
          {props?.cell?.row?.original?.extendedResults?.find(row => row.er_code === 'SO')?.er_value}
        </>
      )
    }
  )
}

function ColumnTens({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-10',
  label = 'HeaderTens'
}) {
  return (
    {
      Header: <Label data={label} />,
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Tens',
      Cell: (props) => (
        <>
          {props?.cell?.row?.original?.extendedResults?.find(row => row.er_code === 'TEN_NUM')?.er_value}
        </>
      )
    }
  )
}

function ColumnXs({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-10',
  label = 'HeaderXs'
}) {
  return (
    {
      Header: <Label data={label} />,
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Xs',
      Cell: (props) => (
        <>
          {props?.cell?.row?.original?.extendedResults?.find(row => row.er_code === 'XS_NUM')?.er_value}
        </>
      )
    }
  )
}
